module.exports = __webpack_public_path__ + "static/media/VisbyCF-Regular.a0374f81.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VisbyCF-Regular.woff
// module id = 795
// module chunks = 0